// extracted by mini-css-extract-plugin
module.exports = {"sj2dupj":"sj2dupj"};